import React from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

// Signature palette tokens (DESIGN.md):
// ink #181d26, forest #0a2e0e, coral #aa2d00, mint #a8d8c4, peach #fcab79, mustard #d9a441
const BAR_PALETTE = ["#181d26", "#0a2e0e", "#aa2d00", "#d9a441", "#fcab79", "#a8d8c4"];

const BarChart = ({ data }) => {
    const chartData = {
        labels: data.labels,
        datasets: [
            {
                label: "Campaign Performance",
                data: data.values,
                backgroundColor: data.values.map((_, i) => BAR_PALETTE[i % BAR_PALETTE.length]),
                borderColor: "#181d26",
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: "top",
            },
            tooltip: {
                enabled: true,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: "Campaigns",
                },
            },
            y: {
                title: {
                    display: true,
                    text: "Transactions",
                },
                beginAtZero: true,
            },
        },
    };

    return <Bar data={chartData} options={options} />;
};

export default BarChart;
